module.exports = __webpack_public_path__ + "static/servers-dac211ca99ec8ee32bba94b9a6edf189.svg";